import { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';

const useProjectNextCode = (params: CommonIdReqDto) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [codeList, setCodeList] = useState<NextProjectListDto[]>();

  const {  } = useQuery(
    [endpoints.project.next_project, params],
    () =>
      fetcher.project.postNextProjectList(params),
    {
      enabled: (!!params.id) && params.id > 0,
      onSuccess: (res: CommonListResDto) => {
        switch (res.code) {
          case 200:
            setCodeList(res.result?.list);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  return { codeList };
};

export default useProjectNextCode;
